export default "__VITE_ASSET__Hwzd1VoE__"